<script setup lang="ts"></script>

<template>
  <icon name="mingcute:drive-fill" />
</template>

<style scoped></style>
